<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>
<script>
import {wlData} from '../../frontend/src/assets/js/constants';
import { loginRedirect } from './assets/js/http';
// set the page title and favicon
document.title = wlData.name+' Admin Dashboard'; // eslint-disable-line no-undef
export default {
  name: 'App',
  async beforeCreate(){
    try {
      if(window.User){
        this.$store.dispatch('localsThroughWindow')
      } else {
        await this.$store.dispatch('loadLocals');
      }
      if (this.$store.state.theme === 'dark')
        this.$vuetify.theme.dark = true
      else
        this.$vuetify.theme.dark = false
    } catch (error) {
      console.error(error);
      if (!this.$store.getters.isLoggedIn) {
        const host = location.hostname;
        if (host !== 'localhost' && host !== '127.0.0.1') {
          location = loginRedirect();
        }
      }
    }
  }
};
</script>
<style lang="scss">
  @import './assets/sass/global.sass';
</style>